import { ArrowBigLeftIcon, ArrowBigRightIcon } from "lucide-react";
import React, { useEffect, useState } from "react";

export const CharaSelect: React.FC<{ setIcon: React.Dispatch<React.SetStateAction<string>> }> = ({ setIcon }) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const charaChipName = ["spr", "smr", "atm", "wnt"];
  const ccn = charaChipName.length;

  useEffect(() => {
    setIcon(charaChipName[selectedIndex % ccn]);
  }, [selectedIndex]);

  return <div className="flex flex-col justify-center items-center">
    <div className="relative w-60 h-[120px] md:h-[140px]">

      {charaChipName.map((name, i) => {
        const getOffset = (index: number) => {
          const rawOffset = index - selectedIndex;
          // 最短距離を計算（循環を考慮）
          if (rawOffset > ccn + 2) return rawOffset - ccn * 2;
          if (rawOffset < -ccn + 2) return rawOffset + ccn * 2;
          return rawOffset;
        };

        const offset1 = getOffset(i);
        const offset2 = getOffset(i + ccn);
        const getZIndex = (offset: number) => offset >= 0 ? 50 - offset : 50 + Math.abs(offset);
        const isVisible = (offset: number) => offset >= 0 && offset < ccn;

        return <React.Fragment key={i}>
          <div
            className={`w-20 h-[80px] md:h-[110px] absolute inset-0 m-auto bg-gradient-to-br from-white to-gray-200 rounded-xl flex items-start justify-start cursor-pointer transition-all duration-300 border-[3px] border-white/50 shadow-[0_4px_6px_rgba(0,0,0,0.3)]`}
            style={{
              transform: `translateX(${offset1 * 40 - 60}px) rotate(${offset1 * 3 - 4}deg) scale(${offset1 === 0 ? 1.2 : 0.9})`,
              transformOrigin: "bottom center",
              zIndex: getZIndex(offset1),
              opacity: isVisible(offset1) ? 1 : 0,
              pointerEvents: isVisible(offset1) ? 'auto' : 'none'
            }}
            onClick={() => setSelectedIndex(i)}
          >
            <img src={`${process.env.PUBLIC_URL}/img/${name}.webp`} className="w-full h-full object-contain rounded-[0.6rem]" />
          </div>
          <div
            className={`w-20 h-[80px] md:h-[110px] absolute inset-0 m-auto bg-gradient-to-br from-white to-gray-200 rounded-xl flex items-start justify-start cursor-pointer transition-all duration-300 border-[3px] border-white/50 shadow-[0_4px_6px_rgba(0,0,0,0.3)]`}
            style={{
              transform: `translateX(${offset2 * 40 - 60}px) rotate(${offset2 * 3 - 4}deg) scale(${offset2 === 0 ? 1.2 : 0.9})`,
              transformOrigin: "bottom center",
              zIndex: getZIndex(offset2),
              opacity: isVisible(offset2) ? 1 : 0,
              pointerEvents: isVisible(offset2) ? 'auto' : 'none'
            }}
            onClick={() => setSelectedIndex(i + ccn)}
          >
            <img src={`${process.env.PUBLIC_URL}/img/${name}.webp`} className="w-full h-full object-contain rounded-[0.6rem]" />
          </div>
        </React.Fragment>;
      })}
    </div>
    <div className="flex flex-row justify-center items-center gap-2">
      <button
        onClick={() => { setSelectedIndex(prev => prev <= 0 ? ccn * 2 - 1 : prev - 1) }}
        className="flex items-center justify-center gap-2 px-8 py-2 bg-gradient-to-br from-[#0575E6] to-[#021B79] text-white font-semibold rounded-lg border-none cursor-pointer transition-all duration-300 text-base hover:bg-gradient-to-br hover:from-[#1585f6] hover:to-[#122b89] hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(212,165,116,0.3)]"
      >
        <ArrowBigLeftIcon size={20} />
      </button>
      <button
        onClick={() => { setSelectedIndex(prev => (prev + 1 >= ccn * 2 ? 0 : prev + 1)) }}
        className="flex items-center justify-center gap-2 px-8 py-2 bg-gradient-to-br from-[#0575E6] to-[#021B79] text-white font-semibold rounded-lg border-none cursor-pointer transition-all duration-300 text-base hover:bg-gradient-to-br hover:from-[#1585f6] hover:to-[#122b89] hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(212,165,116,0.3)]"
      >
        <ArrowBigRightIcon size={20} />
      </button>
    </div>
  </div>;
};
